import { configureStore } from "@reduxjs/toolkit";
import map from "./slices/mapSlice";
import layer from "./slices/layerSlice";
import measure from "./slices/measureSlice";
import draw from "./slices/drawSlice";
import aoi from "./slices/aoiSlice";

export const store = configureStore({
  reducer: {
    map,
    layer,
    measure,
    draw,
    aoi,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
